import { useCallback, useMemo } from 'react';
import { scrollToWithHeaderHeight } from '../../ScrollUtils';
import { useScrollFixed } from '../useScrollFixed';
/**
 * ヘッダーを制御するuse
 * @param unit
 * @returns {*}
 */
export const useProfessionalUnitHeaderControl = (unit) => {
    const { headerHeightRef, isFixed, ref } = useScrollFixed.useScrollFixedDetect();
    const categories = useMemo(() => [
        {
            count: unit.solutions.length,
            text: '事例',
            unit: '件',
            value: 'solutions',
        },
        {
            count: unit.projectCareers.length,
            text: 'プロジェクト実績',
            unit: '件',
            value: 'project_careers',
        },
        {
            count: unit.professionals.length,
            text: '登録コンサルタント',
            unit: '名',
            value: 'professionals',
        },
        // TODO: 実装後に再度表示
        // {
        //   count: unit.documents_count || 2,
        //   text: 'ダウンロード資料',
        //   unit: '件',
        //   value: 'documents',
        // },
        // {
        //   count: unit.seminars || 1,
        //   text: 'セミナー情報',
        //   unit: '件',
        //   value: 'seminars',
        // },
    ], [unit]);
    /**
     * ヘッダーのカテゴリクリック時のイベント
     * @type {(function(*): void)|*}
     */
    const onClickCategory = useCallback((e) => {
        const { value } = e.currentTarget;
        scrollToWithHeaderHeight(`section_${value}`);
    }, []);
    return {
        categories,
        headerHeightRef,
        isFixed,
        onClickCategory,
        ref,
    };
};
export const useProfessionalUnitHeader = {
    useProfessionalUnitHeaderControl,
};
